module.exports = __webpack_public_path__ + "media/dashboard/assets/images/email-622df1b413b68468ea92485ae8371b95.png";